import React from "react";
import "../index.css";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import * as Yup from "yup";
function Setting() {
  const LoginSchema = Yup.object().shape({
    mobile: Yup.string()
      .required("required")
      .min(10, "MobileNo must be 10 characters at minimum"),
    empname: Yup.string().required("required"),
    corporateName: Yup.string().required("required"),
    noofemployees: Yup.string().required("required"),
    designation: Yup.string().required("required"),
    email: Yup.string().email("Invalid email format").required("required"),
  });
  return (
    <div className="p-3">
      <div>
        <ul className="nav nav-tabs" id="myTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active tab-item "
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="true"
            >
              Profile
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link tab-item "
              id="admin-tab"
              data-bs-toggle="tab"
              data-bs-target="#admin"
              type="button"
              role="tab"
              aria-controls="admin"
              aria-selected="false"
            >
              Admin
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link tab-item "
              id="upload-tab"
              data-bs-toggle="tab"
              data-bs-target="#upload"
              type="button"
              role="tab"
              aria-controls="upload"
              aria-selected="false"
            >
              Upload Logo
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link tab-item "
              id="agreement-tab"
              data-bs-toggle="tab"
              data-bs-target="#agreement"
              type="button"
              role="tab"
              aria-controls="agreement"
              aria-selected="false"
            >
              Agreement
            </button>
          </li>
        </ul>
        <div className="tab-content mt-3" id="myTabsContent">
          <div
            className="tab-pane fade show active"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div>
              <Formik
                initialValues={{
                  empname: "",
                  designation: "",
                  corporateName: "",
                  noofemployees: "",
                  mobile: "",
                  email: "",
                }}
                validationSchema={LoginSchema}
                onSubmit={(values) => {
                  console.log("values", values);
                  //   let dto = {
                  //     ...values,
                  //     emailId: email,
                  //     corporateId: corporateId,
                  //   };
                  //   console.log("dto", dto);
                  //   const token = localStorage.getItem("token");
                  //   setIsLoader(true);
                  //   axios
                  //     .request(`${APIURL}/customer/workspacecreate`, {
                  //       method: "POST",
                  //       data: dto,
                  //       headers: {
                  //         Authentication: token,
                  //         "Content-Type": "application/json",
                  //        ,
                  //       },
                  //     })
                  //     .then((response) => {
                  //       console.log("response:::", response);
                  //       setIsLoader(false);
                  //       toast.success("Create your workspace successfully...");
                  //     })
                  //     .catch((error) => {
                  //       console.log("error", error);
                  //       setIsLoader(false);
                  //       toast.warning("User does not exist...");
                  //     });
                }}
              >
                {({ touched, errors }) => (
                  <>
                    <Form className="">
                      <div>
                        <div>
                          <h4
                            className="mt-3 mb-4 text-center"
                            style={{ color: "#66a725", fontWeight: 800 }}
                          >
                            Profile
                          </h4>
                          <div className="">
                            <label>Email*</label>
                            <Field
                              type="email"
                              name="email"
                              placeholder="Enter Company Email"
                              className={`form-control
                          ${touched.email && errors.email ? "is-invalid" : ""}`}
                            />
                            <ErrorMessage
                              component="div"
                              name="email"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="mt-2">
                            <label>Model*</label>
                            <Field
                              as="select"
                              name="model"
                              placeholder="Enter no. Model"
                              className={`form-control
                          ${touched.model && errors.model ? "is-invalid" : ""}`}
                            >
                              <option value="">Select Model</option>
                              <option value="assured">Assured</option>
                              <option value="noAssured">Non Assured</option>
                            </Field>
                            <ErrorMessage
                              component="div"
                              name="model"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="mt-2">
                            <label>Company Name*</label>
                            <Field
                              type="text"
                              name="corporateName"
                              placeholder="Enter Company Name"
                              className={`form-control
                          ${
                            touched.corporateName && errors.corporateName
                              ? "is-invalid"
                              : ""
                          }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="corporateName"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="mt-2">
                            <label>Your Name*</label>
                            <Field
                              type="text"
                              name="empname"
                              placeholder="Enter Name"
                              className={`form-control
                          ${
                            touched.empname && errors.empname
                              ? "is-invalid"
                              : ""
                          }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="empname"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="mt-2">
                            <label>Designation*</label>
                            <Field
                              type="text"
                              name="designation"
                              placeholder="Enter Designation"
                              className={`form-control
                          ${
                            touched.designation && errors.designation
                              ? "is-invalid"
                              : ""
                          }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="designation"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="mt-2">
                            <label>Mobile No*</label>
                            <Field
                              type="number"
                              name="mobile"
                              placeholder="Enter Mobile No"
                              className={`form-control
                          ${
                            touched.mobile && errors.mobile ? "is-invalid" : ""
                          }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="mobile"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="mt-2">
                            <label>No. of employees*</label>
                            <Field
                              type="number"
                              name="noofemployees"
                              placeholder="Enter no. of employees"
                              className={`form-control
                          ${
                            touched.noofemployees && errors.noofemployees
                              ? "is-invalid"
                              : ""
                          }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="noofemployees"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="mt-2">
                            <label>Set up (customization in HR app)*</label>
                            <Field
                              as="select"
                              name="set"
                              placeholder="Enter no. Set up"
                              className={`form-control
                          ${touched.set && errors.set ? "is-invalid" : ""}`}
                            >
                              <option value="">Select..</option>
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </Field>
                            <ErrorMessage
                              component="div"
                              name="set"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="mt-2">
                            <label>Funding option*</label>
                            <Field
                              as="select"
                              name="fOption"
                              placeholder="Enter no. Funding option"
                              className={`form-control
                          ${
                            touched.fOption && errors.fOption
                              ? "is-invalid"
                              : ""
                          }`}
                            >
                              <option value="">Select..</option>
                              <option value="own">Own</option>
                              <option value="financier">Financier</option>
                            </Field>
                            <ErrorMessage
                              component="div"
                              name="fOption"
                              className="invalid-feedback"
                            />
                          </div>

                          <button
                            className="btn btn-success mt-3"
                            type="submit"
                            style={{ backgroundColor: "#66a725" }}
                          >
                            {/* {isLoader ? (
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        ) : (
                          "Submit"
                                              )} */}
                            Submit
                          </button>
                        </div>
                      </div>
                    </Form>
                  </>
                )}
              </Formik>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="admin"
            role="tabpanel"
            aria-labelledby="admin-tab"
          >
            Admin
          </div>
          <div
            className="tab-pane fade"
            id="upload"
            role="tabpanel"
            aria-labelledby="upload-tab"
          >
            Upload Logo
          </div>
          <div
            className="tab-pane fade"
            id="agreement"
            role="tabpanel"
            aria-labelledby="agreement-tab"
          >
            Agreement
          </div>
        </div>
      </div>
    </div>
  );
}

export default Setting;
